module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Story Devotional: Discover Your Role In God’s Story: 365 Devotions")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txaa1",
    staticStyle: {
      "margin-top": "10%"
    },
    attrs: {
      "id": "p0005-02-1"
    }
  }, [_c('span', [_vm._v("Give thanks to the Lord, for he is good;")])]), _vm._v(" "), _c('p', {
    staticClass: "txaa"
  }, [_c('span', [_vm._v("his love endures forever.")])]), _vm._v(" "), _c('p', {
    staticClass: "txaa1",
    attrs: {
      "id": "p0005-02-2"
    }
  }, [_c('span', [_vm._v("Let the redeemed of the Lord tell their story—")])]), _vm._v(" "), _c('p', {
    staticClass: "txaa"
  }, [_c('span', [_vm._v("those he redeemed from the hand of the foe, ")])]), _vm._v(" "), _c('p', {
    staticClass: "txaa1"
  }, [_c('span', [_vm._v("those he gathered from the lands, ")])]), _vm._v(" "), _c('p', {
    staticClass: "txaa"
  }, [_c('span', [_vm._v("from east and west, from north and south.")])]), _vm._v(" "), _c('p', {
    staticClass: "txab",
    attrs: {
      "id": "p0005-02-3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PSALM")]), _vm._v(" 107: 1–3 ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 66
// module chunks = 0